export enum FeatureFlag {
  DashboardCustomRoles = 'dashboard-custom-roles',
  EnableCustomCSVStatements = 'enable-custom-csv-statements',
  EnableDeviceMFA = 'enable-device-mfa',
  HasInternationalWires = 'has-international-wires',
}
